import React from "react";

import { Error, RefreshButton } from "./styled";

const ErrorScreen = () => {
  return (
    <Error>
      <p>Ocorreu algum erro. Confira sua conexão com a internet.</p>
      <RefreshButton onClick={() => window.location.reload()}>
        Recarregar
      </RefreshButton>
      <RefreshButton
        onClick={() =>
          window.location.replace("/")
        }
      >
        Home
      </RefreshButton>
    </Error>
  );
};

export default ErrorScreen;
